<template>
    <div>
        <el-form
            class="custom_field_detail_form"
            v-if="detailsFieldsList.length > 0"
            :label-position="form_label_position || 'top'"
            :label-suffix="form_label_suffix || ''"
            size="small"
            :class="custom_form_class"
        >
            <el-row :gutter="24" type="flex" style="flex-wrap: wrap">
                <el-col v-for="field in detailsFieldsList" :key="field.field_id" :span="field.col_span || 12">
                    <el-form-item :label="field.field_name">
                        <div v-if="field.field_type === 'radio' && customerFieldDetail[field.field_key]">
                            <el-tag
                                size="small"
                                type="info"
                                v-if="field.tag_interaction"
                                v-text="customerFieldDetail[field.field_key].text"
                            >
                            </el-tag>
                            <div v-else v-text="customerFieldDetail[field.field_key].text"></div>
                        </div>
                        <div v-else-if="field.field_type === 'checkbox' && customerFieldDetail[field.field_key]">
                            <div style="display: flex; gap: 6px" v-if="field.tag_interaction">
                                <el-tag
                                    size="small"
                                    type="info"
                                    v-for="(tag, tagIndex) in customerFieldDetail[field.field_key].text"
                                    :key="tagIndex"
                                    v-text="tag"
                                >
                                </el-tag>
                            </div>
                            <div
                                v-else
                                v-text="
                                    customerFieldDetail[field.field_key] && customerFieldDetail[field.field_key].text
                                        ? customerFieldDetail[field.field_key].text.join()
                                        : ''
                                "
                            ></div>
                        </div>
                        <div v-else-if="field.field_type === 'table'">
                            <ul class="table_list">
                                <li class="table_item" v-for="(row, $index) in customerFieldDetail[field.field_key]">
                                    <div :key="child.field_key" v-for="child in field._child">
                                        <p class="child_label" v-text="child.field_name"></p>
                                        <div class="child_content">
                                            <div v-if="child.field_type === 'department'">
                                                <el-tooltip
                                                    :content="dep.full_path"
                                                    effect="dark"
                                                    placement="top"
                                                    v-for="dep in row[child.field_key]"
                                                    :key="dep.title"
                                                >
                                                    <span style="margin-right: 10px">{{ dep.title }}</span>
                                                </el-tooltip>
                                            </div>
                                            <div v-else-if="child.field_type === 'checkbox'">
                                                <div v-if="child.extend && child.extend.tag_interaction">
                                                    <el-tag
                                                        size="small"
                                                        type="info"
                                                        v-for="(tag, tagIndex) in row[child.field_key]"
                                                        :key="tagIndex"
                                                        v-text="tag"
                                                    >
                                                    </el-tag>
                                                </div>
                                                <div
                                                    v-else
                                                    v-text="row[child.field_key] ? row[child.field_key].join() : ''"
                                                ></div>
                                            </div>
                                            <div class="image_outer_wrap" v-else-if="child.field_type === 'image'">
                                                <ul class="upload_img_list">
                                                    <li
                                                        @click="handleClickPreview(img)"
                                                        class="upload_img_item"
                                                        v-for="(img, img_idx) in row[child.field_key]"
                                                    >
                                                        <img :src="img.file_path" />
                                                    </li>
                                                </ul>
                                            </div>
                                            <div v-else-if="child.field_type === 'file'">
                                                <ul
                                                    class="table_file_list"
                                                    v-if="row[child.field_key] && row[child.field_key].length"
                                                >
                                                    <li
                                                        class="table_file_item"
                                                        v-for="(file, file_idx) in row[child.field_key]"
                                                    >
                                                        <div class="file_left_wrap">
                                                            <img
                                                                alt=""
                                                                class="file_img"
                                                                src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                                            />
                                                            <div class="file_info_wrap">
                                                                <p
                                                                    @click="handleClickDownloadFile(file)"
                                                                    class="file_name"
                                                                    v-text="file.file_name"
                                                                ></p>
                                                                <p class="file_size" v-text="file.file_size"></p>
                                                            </div>
                                                        </div>
                                                        <div class="file_right_wrap">
                                                            <el-tooltip content="预览" effect="dark" placement="top">
                                                                <i
                                                                    @click="handleClickPreview(file)"
                                                                    class="iconfont icon-yanjing"
                                                                ></i>
                                                            </el-tooltip>
                                                            <span class="line"></span>
                                                            <el-tooltip content="下载" effect="dark" placement="top">
                                                                <i
                                                                    @click="handleClickDownloadFile(file)"
                                                                    class="el-icon-download"
                                                                >
                                                                </i>
                                                            </el-tooltip>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div v-else-if="child.field_type === 'ID_card'">
                                                <div
                                                    v-if="row[child.field_key] && row[child.field_key].id_card"
                                                    v-text="'身份证号：' + row[child.field_key].id_card"
                                                ></div>
                                                <div
                                                    v-if="row[child.field_key] && row[child.field_key].name"
                                                    v-text="'姓名：' + row[child.field_key].name"
                                                ></div>
                                                <div
                                                    v-if="row[child.field_key] && row[child.field_key].birthday"
                                                    v-text="'出生日期：' + row[child.field_key].birthday"
                                                ></div>
                                                <div
                                                    v-if="row[child.field_key] && row[child.field_key].address"
                                                    v-text="'家庭住址：' + row[child.field_key].address"
                                                ></div>
                                            </div>
                                            <div v-else-if="child.field_type === 'telephone'">
                                                <div
                                                    v-if="
                                                        row[child.field_key] && row[child.field_key].phone_type == '1'
                                                    "
                                                    v-text="
                                                        '（' +
                                                        row[child.field_key].prefix +
                                                        '）' +
                                                        (isPhoneEncryption ? maskPhoneNumber(row[child.field_key].phone_number) : row[child.field_key].phone_number)
                                                    "
                                                ></div>
                                                <div
                                                    v-if="
                                                        row[child.field_key] && row[child.field_key].phone_type == '2'
                                                    "
                                                    v-text="
                                                        row[child.field_key].prefix
                                                            ? row[child.field_key].prefix +
                                                              '-' +
                                                              row[child.field_key].phone_number
                                                            : (isPhoneEncryption ? maskPhoneNumber(row[child.field_key].phone_number) : row[child.field_key].phone_number)
                                                    "
                                                ></div>
                                            </div>
                                            <div v-else-if="child.field_type === 'paying_teller'">
                                                <div
                                                    v-if="row[child.field_key] && row[child.field_key].account_type"
                                                    v-text="
                                                        row[child.field_key].account_type === '1'
                                                            ? '账户类型：个人账户'
                                                            : '账户类型：对公账户'
                                                    "
                                                ></div>
                                                <div
                                                    v-if="row[child.field_key] && row[child.field_key].account_name"
                                                    v-text="'户名：' + row[child.field_key].account_name"
                                                ></div>
                                                <div
                                                    v-if="row[child.field_key] && row[child.field_key].card_number"
                                                    v-text="'账号：' + row[child.field_key].card_number"
                                                ></div>
                                                <div
                                                    v-if="row[child.field_key] && row[child.field_key].bank_name"
                                                    v-text="'所属银行：' + row[child.field_key].bank_name"
                                                ></div>
                                                <div
                                                    v-if="row[child.field_key] && row[child.field_key].bank_branch"
                                                    v-text="'银行支行：' + row[child.field_key].bank_branch"
                                                ></div>
                                            </div>
                                            <div v-else v-text="row[child.field_key]"></div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div v-else-if="field.field_type === 'department'">
                            <el-tooltip
                                :content="dep.title"
                                effect="dark"
                                placement="top"
                                v-for="dep in customerFieldDetail[field.field_key]"
                                :key="dep.title"
                            >
                                <span style="margin-right: 10px">{{ dep.title }}</span>
                            </el-tooltip>
                        </div>
                        <div class="image_outer_wrap" v-else-if="field.field_type === 'image'">
                            <ul class="upload_img_list">
                                <li
                                    @click="handleClickPreview(img)"
                                    class="upload_img_item"
                                    v-for="(img, img_idx) in customerFieldDetail[field.field_key]"
                                >
                                    <img :src="img.file_path" />
                                </li>
                            </ul>
                        </div>
                        <div v-else-if="field.field_type === 'file'">
                            <ul class="table_file_list">
                                <li
                                    class="table_file_item"
                                    v-for="(file, file_idx) in customerFieldDetail[field.field_key]"
                                >
                                    <div class="file_left_wrap">
                                        <img
                                            alt=""
                                            class="file_img"
                                            src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                        />
                                        <div class="file_info_wrap">
                                            <p
                                                @click="handleClickDownloadFile(file)"
                                                class="file_name"
                                                v-text="file.file_name"
                                            ></p>
                                            <p class="file_size" v-text="file.file_size"></p>
                                        </div>
                                    </div>
                                    <div class="file_right_wrap">
                                        <el-tooltip content="预览" effect="dark" placement="top">
                                            <i @click="handleClickPreview(file)" class="iconfont icon-yanjing"></i>
                                        </el-tooltip>
                                        <span class="line"></span>
                                        <el-tooltip content="下载" effect="dark" placement="top">
                                            <i @click="handleClickDownloadFile(file)" class="el-icon-download"> </i>
                                        </el-tooltip>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div v-else-if="field.field_type === 'ID_card'">
                            <div
                                v-if="
                                    customerFieldDetail[field.field_key] && customerFieldDetail[field.field_key].id_card
                                "
                                v-text="'身份证号：' + customerFieldDetail[field.field_key].id_card"
                            ></div>
                            <div
                                v-if="customerFieldDetail[field.field_key] && customerFieldDetail[field.field_key].name"
                                v-text="'姓名：' + customerFieldDetail[field.field_key].name"
                            ></div>
                            <div
                                v-if="
                                    customerFieldDetail[field.field_key] &&
                                    customerFieldDetail[field.field_key].birthday
                                "
                                v-text="'出生日期：' + customerFieldDetail[field.field_key].birthday"
                            ></div>
                            <div
                                v-if="
                                    customerFieldDetail[field.field_key] && customerFieldDetail[field.field_key].address
                                "
                                v-text="'家庭住址：' + customerFieldDetail[field.field_key].address"
                            ></div>
                        </div>
                        <div v-else-if="field.field_type === 'telephone'">
                            <div
                                v-if="
                                    customerFieldDetail[field.field_key] &&
                                    customerFieldDetail[field.field_key].phone_type == '1'
                                "
                                v-text="
                                    '（' +
                                    customerFieldDetail[field.field_key].prefix +
                                    '）' +
                                    (isPhoneEncryption ? maskPhoneNumber(customerFieldDetail[field.field_key].value) : customerFieldDetail[field.field_key].value)
                                "
                            ></div>
                            <div
                                v-if="
                                    customerFieldDetail[field.field_key] &&
                                    customerFieldDetail[field.field_key].phone_type == '2'
                                "
                                v-text="
                                    customerFieldDetail[field.field_key].prefix
                                        ? customerFieldDetail[field.field_key].prefix +
                                          '-' +
                                          customerFieldDetail[field.field_key].value
                                        : 
                                        (isPhoneEncryption ? maskPhoneNumber(customerFieldDetail[field.field_key].value) : customerFieldDetail[field.field_key].value)
                                "
                            ></div>
                        </div>
                        <div v-else-if="field.field_type === 'address'">
                            <div
                                v-if="customerFieldDetail[field.field_key] && customerFieldDetail[field.field_key].text"
                                v-text="customerFieldDetail[field.field_key].text"
                            ></div>
                            <div
                                v-if="
                                    customerFieldDetail[field.field_key] &&
                                    customerFieldDetail[field.field_key].detail_address
                                "
                                v-text="customerFieldDetail[field.field_key].detail_address"
                            ></div>
                        </div>
                        <div v-else-if="field.field_type === 'relate_approve_form'">
                            <ul class="relate_approve_form_list">
                                <li
                                    :key="approve.approval_id"
                                    class="relate_approve_form_item"
                                    v-for="approve in customerFieldDetail[field.field_key]"
                                >
                                    <div class="approve_info_wrap">
                                        <div>
                                            <span class="approve_title" v-text="approve.co_type_title"></span>
                                            <span
                                                :class="'approve_status_' + approve.status"
                                                class="approve_status"
                                                v-text="approve.status_name"
                                            ></span>
                                        </div>
                                        <div
                                            @click="handleClickRelateApproveDetail(approve.approval_id)"
                                            class="detail_btn"
                                        >
                                            详情
                                        </div>
                                    </div>
                                    <div class="approve_time_wrap" v-if="approve.userInfo">
                                        <span v-text="approve.userInfo.name"></span>
                                        <span>提交于</span>
                                        <span v-text="approve.create_date"></span>
                                    </div>
                                    <div
                                        class="approve_content_wrap"
                                        v-if="approve.overview_fields && approve.overview_fields.length"
                                    >
                                        <p v-for="overview in approve.overview_fields">
                                            <span v-text="overview.field_name + '：'" style="color: #666666"></span>
                                            <span
                                                v-if="overview.field_type == 'money' && overview.field_value"
                                                v-text="
                                                    overview.field_value.format_price + '' + overview.field_value.unit
                                                "
                                            ></span>
                                            <span
                                                v-else-if="overview.field_type == 'checkbox' && overview.field_value"
                                                v-text="overview.field_value.join(',')"
                                            ></span>
                                            <span
                                                v-else-if="overview.field_type == 'telephone' && overview.field_value"
                                                v-text="overview.field_value.phone_number"
                                            ></span>
                                            <span
                                                v-else-if="
                                                    overview.field_type == 'date_range' &&
                                                    overview.field_value &&
                                                    overview.field_value.value
                                                "
                                                v-text="overview.field_value.value.join(' - ')"
                                            ></span>
                                            <span
                                                v-else-if="overview.field_type == 'address' && overview.field_value"
                                                v-text="overview.field_value.address_text"
                                            ></span>
                                            <span
                                                v-else-if="
                                                    overview.field_type == 'contact' &&
                                                    overview.field_value &&
                                                    overview.field_value.text
                                                "
                                            >
                                                <span
                                                    v-for="text in overview.field_value.text"
                                                    v-if="overview.field_value.text.length > 0"
                                                    >{{ text.text }},</span
                                                >
                                            </span>
                                            <span
                                                v-else-if="
                                                    overview.field_type == 'department' &&
                                                    overview.field_value &&
                                                    overview.field_value.did_title
                                                "
                                            >
                                                <span
                                                    v-if="Array.isArray(overview.field_value.did_title)"
                                                    v-text="overview.field_value.did_title.join(',')"
                                                ></span>
                                                <span v-else v-text="overview.field_value.did_title"></span>
                                            </span>
                                            <span
                                                v-else-if="overview.field_type == 'ID_card' && overview.field_value"
                                                v-text="overview.field_value.id_card"
                                            ></span>
                                            <span
                                                v-else-if="overview.field_type == 'rate' && overview.field_value"
                                                v-text="overview.field_value.value"
                                            ></span>
                                            <span
                                                v-else-if="
                                                    overview.field_type == 'paying_teller' && overview.field_value
                                                "
                                                v-text="overview.field_value.account_name"
                                            ></span>
                                            <span
                                                v-else-if="
                                                    overview.field_type == 'computed_money' && overview.field_value
                                                "
                                                v-text="overview.field_value.format_price"
                                            ></span>
                                            <span v-else v-text="overview.field_value"></span>
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div v-else-if="field.field_type === 'paying_teller'">
                            <div
                                v-if="
                                    customerFieldDetail[field.field_key] &&
                                    customerFieldDetail[field.field_key].account_type
                                "
                                v-text="
                                    customerFieldDetail[field.field_key].account_type === '1'
                                        ? '账户类型：个人账户'
                                        : '账户类型：对公账户'
                                "
                            ></div>
                            <div
                                v-if="
                                    customerFieldDetail[field.field_key] &&
                                    customerFieldDetail[field.field_key].account_name
                                "
                                v-text="'户名：' + customerFieldDetail[field.field_key].account_name"
                            ></div>
                            <div
                                v-if="
                                    customerFieldDetail[field.field_key] &&
                                    customerFieldDetail[field.field_key].card_number
                                "
                                v-text="'账号：' + customerFieldDetail[field.field_key].card_number"
                            ></div>
                            <div
                                v-if="
                                    customerFieldDetail[field.field_key] &&
                                    customerFieldDetail[field.field_key].bank_name
                                "
                                v-text="'所属银行：' + customerFieldDetail[field.field_key].bank_name"
                            ></div>
                            <div
                                v-if="
                                    customerFieldDetail[field.field_key] &&
                                    customerFieldDetail[field.field_key].bank_branch
                                "
                                v-text="'银行支行：' + customerFieldDetail[field.field_key].bank_branch"
                            ></div>
                        </div>
                        <div v-else-if="field.field_type === 'invoice'">
                            <!-- <ul>
                                <li class="upload_invoice_item" v-for="invoice in customerFieldDetail[field.field_key]">
                                    <div class="invoice_title_wrap">
                                        <span
                                            class="invoice_title"
                                            v-text="invoice.title ? invoice.title : '发票'"
                                        ></span>
                                        <span class="invoice_total_amount" v-text="'￥' + invoice.total_amount"></span>
                                    </div>
                                    <el-button @click="handleClickInvoicePreview(invoice)" type="text"
                                        >发票预览
                                    </el-button>
                                </li>
                            </ul> -->
                        </div>
                        <div v-else-if="field.field_type === 'contact'">
                            <ul class="contact_field_list">
                                <li :key="user.uid" v-for="user in customerFieldDetail[field.field_key]">
                                    <span v-if="user.name">
                                        <PersonnelCard :userId="user.uid || user.id" v-if="user.uid">
                                            <template slot="container">
                                                <div class="user-avatar-btn">
                                                    <img :src="user.avatar" alt="" />
                                                    <span>{{ user.name }}</span>
                                                </div>
                                            </template>
                                        </PersonnelCard>
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div v-else-if="field.field_type === 'money' || field.field_type === 'customer_contact'">
                            {{ customerFieldDetail[field.field_key] }}
                        </div>
                        <div v-else>
                            {{ customerFieldDetail[field.field_key] && customerFieldDetail[field.field_key].value }}
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div v-else class="no_data">没有更多内容</div>
        <el-image :preview-src-list="currentList" :src="currentUrl" class="my-img" ref="myImg" style="display: none">
        </el-image>
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            custom-class="upload_invoice_dialog"
            append-to-body
            size="100%"
            title="发票明细"
            :visible.sync="invoiceDrawerShow"
            v-if="invoiceDrawerShow"
        >
            <el-image
                :preview-src-list="[invoiceForm.file_path]"
                :src="invoiceForm.file_path"
                v-if="invoiceForm.file_type === 'image'"
            >
            </el-image>
            <el-button @click="handleClickInvoicePdfReview" type="text" v-else>发票预览 </el-button>
            <el-form label-suffix="：" size="mini" class="mt_15">
                <div class="page_little_title">发票基本信息</div>
                <el-form-item label="发票类型" prop="op" v-if="invoiceForm.invoice_type">
                    <div v-text="invoiceForm.op ? invoiceForm.invoice_type : '其它'"></div>
                </el-form-item>
                <el-form-item label="发票代码" prop="invoice_code" v-if="invoiceForm.invoice_code">
                    <div v-text="invoiceForm.invoice_code"></div>
                </el-form-item>
                <el-form-item label="发票号码" prop="invoice_number">
                    <div v-text="invoiceForm.invoice_number"></div>
                </el-form-item>
                <el-form-item label="开票日期" prop="invoice_date" v-if="invoiceForm.invoice_date">
                    <div v-text="invoiceForm.invoice_date"></div>
                </el-form-item>
                <el-form-item label="校验码" prop="checkCode" v-if="invoiceForm.check_code">
                    <div v-text="invoiceForm.check_code"></div>
                </el-form-item>
                <div
                    class="page_little_title"
                    v-if="
                        invoiceForm.purchaser_name ||
                        invoiceForm.purchaser_tax_number ||
                        invoiceForm.purchaser_contact_info ||
                        invoiceForm.purchaser_bank_account_info
                    "
                >
                    购方信息
                </div>
                <el-form-item label="名称" prop="purchaser_name" v-if="invoiceForm.purchaser_name">
                    <div v-text="invoiceForm.purchaser_name"></div>
                </el-form-item>
                <el-form-item label="纳税人识别号" prop="purchaser_tax_number" v-if="invoiceForm.purchaser_tax_number">
                    <div v-text="invoiceForm.purchaser_tax_number"></div>
                </el-form-item>
                <el-form-item
                    label="地址、电话"
                    prop="purchaser_contact_info"
                    v-if="invoiceForm.purchaser_contact_info"
                >
                    <div v-text="invoiceForm.purchaser_contact_info"></div>
                </el-form-item>
                <el-form-item
                    label="开户行及账号"
                    prop="purchaser_bank_account_info"
                    v-if="invoiceForm.purchaser_bank_account_info"
                >
                    <div v-text="invoiceForm.purchaser_bank_account_info"></div>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="invoiceDrawerShow = false" size="small">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getFormFields } from "@/api";
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
export default {
    name: "CustomFieldsDetailForm",
    props: [
        "field_table",
        "details",
        "detail_url",
        "detail_query",
        "filter_system",
        "pk_id",
        "get_custom_show_field",
        "mask_phone",
        "form_label_position",
        "form_label_suffix",
        "form_col_span",
        "createTime",
        "custom_form_class",
        "isPhoneEncryption"
    ],
    components: { PersonnelCard },
    data() {
        return {
            detailsFieldsList: [],
            customerFieldDetail: {},
            currentList: [],
            currentUrl: "",
            invoiceDrawerShow: false,
            invoiceForm: {},
        };
    },
    created() {
        this.$emit("loading-change", true);
        if (this.detail_url) {
            this.getCustomFormDetail();
        } else {
            this.customerFieldDetail = JSON.parse(JSON.stringify(this.details));
            this.getDetailsFieldsList();
        }
    },
    methods: {
        //获取详情字段列表
        getDetailsFieldsList() {
            if (this.get_custom_show_field) {
            } else {
                getFormFields({
                    field_form: this.field_table,
                    filter_field_type: "",
                }).then((res) => {
                    if (res.code === 200) {
                        if (this.filter_system) {
                            this.detailsFieldsList = res.data
                                .filter(
                                    (item) =>
                                        item.field_type !== "explain" &&
                                        item.field_type !== "pk" &&
                                        item.is_system == "0"
                                )
                                .map((item) => {
                                    return {
                                        ...item,
                                        ...item.extend,
                                    };
                                });
                        } else {
                            this.detailsFieldsList = res.data
                                .filter((item) => item.field_type !== "explain" && item.field_type !== "pk")
                                .map((item) => {
                                    return {
                                        ...item,
                                        ...item.extend,
                                    };
                                });
                            if (this.customerFieldDetail.seas_id !== "0") {
                                this.detailsFieldsList = this.detailsFieldsList.filter(
                                    (item) => item.field_key !== "salesperson"
                                );
                            }
                        }

                        this.customFormDetailShow(this.detailsFieldsList, this.customerFieldDetail);
                    } else {
                        this.$message.error(res.message);
                    }
                    this.$emit("loading-change", false);
                });
            }
        },
        //获取详情
        getCustomFormDetail() {
            // $.ajax({
            //     type: "POST",
            //     url: this.detail_url,
            //     contentType: "application/json",
            //     data: JSON.stringify(this.detail_query),
            //     dataType: "json",
            //     success: (res) => {
            //         if (res.status === 0) {
            //             this.customerFieldDetail = res.data;
            //             this.getDetailsFieldsList();
            //         } else {
            //             this.$message.error(res.message);
            //             this.$emit("loading-change", false);
            //         }
            //     },
            //     error: () => {},
            // });
        },
        //自定义表单详情显示
        customFormDetailShow(fieldList, data) {
            fieldList.forEach((field) => {
                if (this.form_col_span) {
                    this.$set(field, "col_span", 24);
                }
                if (data.hasOwnProperty(field.field_key)) {
                    if (
                        field.field_type === "address" ||
                        field.field_type === "textarea" ||
                        field.field_type === "explain" ||
                        field.field_type === "table" ||
                        field.field_type === "image" ||
                        field.field_type === "file" ||
                        field.field_type === "ID_card" ||
                        field.field_type === "relate_approve_form" ||
                        field.field_type === "paying_teller"
                    ) {
                        this.$set(field, "col_span", 24);
                    }
                    if (field.field_type === "cascader") {
                        data[field.field_key] = data[field.field_key].text ? data[field.field_key].text : "";
                    } else if (field.field_type === "money" || field.field_type === "computed_money") {
                        const unit = data[field.field_key]
                            ? data[field.field_key].unit === "￥"
                                ? "（CNY-人民币）"
                                : "（USD-美元）"
                            : "";
                        data[field.field_key] = data[field.field_key].text ? data[field.field_key].text + unit : "";
                    } else if (field.field_type === "contact") {
                        data[field.field_key] = data[field.field_key].text;
                    } else if (field.field_type === "customer_contact") {
                        data[field.field_key] = data[field.field_key].text.map((user) => user.name).join();
                    } else if (field.field_type === "department") {
                        if (data[field.field_key].text) {
                            data[field.field_key] = data[field.field_key].text;
                        } else {
                            data[field.field_key] = [];
                        }
                    } else if (field.field_type === "date_range") {
                        const date =
                            data[field.field_key] && data[field.field_key].value
                                ? data[field.field_key].value.join(" - ")
                                : "";
                        const duration =
                            field.extend.auto_compute && data[field.field_key] && data[field.field_key].duration
                                ? `（${data[field.field_key].duration}）`
                                : "";
                        data[field.field_key] = `${date}${duration}`;
                    } else if (field.field_type === "ID_card") {
                        data[field.field_key] = data[field.field_key];
                        if (data[field.field_key].data_desensitization) {
                            if (data[field.field_key].id_card && data[field.field_key].id_card.length) {
                                data[field.field_key].id_card = data[field.field_key].id_card.replace(
                                    /(\d{4})\d+(\d{2})/,
                                    "$1********$2"
                                );
                            }
                        }
                    } else if (field.field_type === "rate") {
                        if (data[field.field_key].point_system === "5") {
                            data[field.field_key] = data[field.field_key].value + "分";
                        } else {
                            data[field.field_key] = data[field.field_key].value * 2 + "分";
                        }
                    } else if (field.field_type === "table") {
                        data[field.field_key].forEach((child) => {
                            child = this.customFormDetailShow(field._child, child);
                        });
                    } else if (field.field_type === "relate_approve_form") {
                        const approval_ids = data[field.field_key].map((item) => item.approval_id);
                        if (approval_ids.length > 0) {
                            this.getRelateApproveDetail(approval_ids).then((res) => {
                                this.$set(data, field.field_key, res);
                            });
                        }
                    } else if (field.field_type === "date" && field.field_name === "创建时间") {
                        data[field.field_key] = data[field.field_key];
                        this.$emit("update:createTime", data[field.field_key] ? data[field.field_key].value : "");
                    } else {
                        data[field.field_key] = data[field.field_key];
                    }
                }
            });
        },
        //获取关联审批详情
        getRelateApproveDetail(approval_ids) {
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: "/admin/field/getapprovals",
                    type: "POST",
                    contentType: "application/json",
                    data: JSON.stringify({ approval_ids }),
                    dataType: "json",
                    success: (res) => {
                        if (res.status === 0) {
                            resolve(res.data);
                        } else {
                            this.$message.error(res.message);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    },
                });
            });
        },

        //点击查看关联审批详情
        handleClickRelateApproveDetail(id) {
            window.open("/admin/work/approve_new?action=wechat&approve_id=" + id);
        },
        //点击预览
        handleClickPreview(file) {
            if (file.file_type && file.file_type.indexOf("image") > -1) {
                this.$refs.myImg.showViewer = true;
                this.currentList = [file.file_path];
                this.currentUrl = file.file_path;
            } else {
                if (file.file_type && file.file_type.indexOf("pdf") > -1) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        //点击下载附件
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },
        //点击查看用户信息
        handleClickUserInfo(uid, item, field_key) {
            if (item && item.userinfo && item.userinfo.source == "miniapp") {
                return this.$set(item, "user_card_info", item.userinfo);
            }
            if (uid == "0") {
                return this.$set(item, "user_card_info", item.userinfo);
            }
            $.ajax({
                type: "POST",
                url: "/Admin/user/userCard",
                contentType: "application/json",
                data: JSON.stringify({ uid }),
                dataType: "json",
                success: (res) => {
                    if (res.status === 0) {
                        if (res.data) {
                            this.$set(item, "user_card_info", res.data);
                            this.$nextTick(() => {
                                if (
                                    this.$refs["user_e_card_popper_" + field_key + "_" + uid] &&
                                    this.$refs["user_e_card_popper_" + field_key + "_" + uid][0]
                                ) {
                                    this.$refs["user_e_card_popper_" + field_key + "_" + uid][0].updatePopper();
                                }
                            });
                        } else {
                            this.$set(item, "user_card_info", {});
                            if (item.userinfo.name.indexOf("已注销") < 0) {
                                item.userinfo.name = item.userinfo.name + "（已注销）";
                            }
                        }
                    } else {
                    }
                },
                error: () => {},
            });
        },

        handleClickInvoicePreview(invoice) {
            this.invoiceDrawerShow = true;
            this.invoiceForm = invoice;
        },

        //pdf类型的发票预览
        handleClickInvoicePdfReview(file_path) {
            window.open(file_path);
        },
        // 隐藏手机号*
        maskPhoneNumber(phoneNumber) {
            if (this.mask_phone) {
                // 正则表达式匹配第4位到第8位的数字
                const regex = /(\d{3})\d{4}(\d{4})/;
                // 替换匹配的部分为星号
                return phoneNumber.replace(regex, "$1****$2");
            } else {
                return phoneNumber;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.custom_field_detail_form {
    ::v-deep {
        .el-form-item {
            margin-bottom: 0;
        }
        .el-form-item__label {
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: rgba(153, 153, 153, 1);
        }
        .el-form-item__content {
            & > div {
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(51, 51, 51, 1);
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
        .contact_field_list {
            display: flex;
            align-items: center;
            gap: 16px;
            flex-wrap: wrap;
            .contact_field_item {
                border-radius: 14px;
                background: #edf0f4;
                display: flex;
                align-items: center;
                .user_header_img {
                    width: 28px;
                    height: 28px;
                    border: 2px solid #ffffff;
                    box-sizing: border-box;
                    border-radius: 50%;
                }
                .user_name {
                    padding: 0 12px;
                    line-height: 22px;
                    max-width: calc(100% - 28px);
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    flex: 1;
                    text-align: center;
                }
            }
        }
    }
}
.manage_customer_form {
    ::v-deep {
        .el-form-item__label,
        .el-form-item__content > div {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(102, 102, 102, 1);
            padding: 0;
        }
        .el-form-item {
            margin-bottom: 12px;
        }
    }
}
.customer_share_detail_form {
    ::v-deep {
        .el-form-item {
            margin-bottom: 16px !important;
        }
    }
}
</style>
